import { FC, useState } from 'react';
import GoalMetDialog from './GoalMetDialog';
import { WeeklySnapshotQueryFilters } from '../WeeklySnapshot';
import { useQueryLoader } from 'react-relay';
import { DashboardGoalMetPassedOrNotQuery } from '../../../graphQLOperations/__generated__/DashboardGoalMetPassedOrNotQuery.graphql';
import { getGoalMetPassedOrNot } from '../../../graphQLOperations/Dashboard';

interface Props {
  percentage: number;
  queryFilters: WeeklySnapshotQueryFilters;
}

const GoalMet: FC<Props> = ({ percentage, queryFilters }) => {
  const [goalMetDialogVisible, setGoalMetDialogVisible] = useState<boolean>(false);
  const [queryReferenceTrue, loadQueryTrue] = useQueryLoader<DashboardGoalMetPassedOrNotQuery>(getGoalMetPassedOrNot);
  const [queryReferenceFalse, loadQueryFalse] = useQueryLoader<DashboardGoalMetPassedOrNotQuery>(getGoalMetPassedOrNot);

  const percentageColor =
    percentage <= 49
      ? '#B71C1B'
      : percentage >= 50 && percentage <= 79
      ? '#FDB814'
      : percentage >= 80
      ? '#008158'
      : undefined;

  const loadQueryHandler = () => {
    loadQueryTrue({
      filter: {
        classIds: queryFilters.classIds,
        siteIds: queryFilters.siteIds,
        gradeLevelIds: queryFilters.gradeLevelIds,
        reportFromDate: queryFilters.reportFromDate,
        reportToDate: queryFilters.reportToDate,
      },
      returnMeetOrPassedSkillGoal: true,
    });
    loadQueryFalse({
      filter: {
        classIds: queryFilters.classIds,
        siteIds: queryFilters.siteIds,
        gradeLevelIds: queryFilters.gradeLevelIds,
        reportFromDate: queryFilters.reportFromDate,
        reportToDate: queryFilters.reportToDate,
      },
      returnMeetOrPassedSkillGoal: false,
    });
    setGoalMetDialogVisible(true);
  };

  return (
    <>
      <div
        id="GoalMetWeekly"
        className="nc_teacher-dashboard-card-clickable lg:p-3 xl:p-4 p-4 sm:col-6 lg:col-12"
        style={{ cursor: 'pointer' }}
        onClick={loadQueryHandler}
      >
        <div className="flex align-items-center text-primary">
          <div className="flex flex-row align-items-center border-none bg-transparent p-0">
            <h1 className="text-primary md:text-2xl text-base"> Goal Met</h1>
            <i className="nc_icon-nc_right icon-sm ml-2"></i>
          </div>
        </div>
        <div className="nc_goal-met-percentage">
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
            <circle cx="5" cy="5" r="5" fill={percentageColor} />
          </svg>
          <p className="xl:text-base text-xs line-height-3 m-0 font-bold">
            <span className="font-bold">{percentage}%</span> met the goal
          </p>
        </div>
      </div>
      {goalMetDialogVisible && (
        <GoalMetDialog
          visible={goalMetDialogVisible}
          setVisible={setGoalMetDialogVisible}
          percentage={percentage}
          queryReferenceTrue={queryReferenceTrue}
          queryReferenceFalse={queryReferenceFalse}
        />
      )}
    </>
  );
};

export default GoalMet;
